import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui'
import './assets/css/style.scss'
import router from './router/'
import Config from './config/app'
import VueCropper from 'vue-cropper'
import * as echarts from 'echarts'
import * as socketApi from './socket';
import { CountDown,Swipe, SwipeItem } from 'vant';
Vue.use(CountDown)
Vue.use(Swipe);
Vue.use(SwipeItem);
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  title: false,
  toolbar: false,
  navbar:false
})
// import uView from "uview-ui";
// Vue.use(uView);
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css' // 这个CSS必须引入
// import 'quill/dist/quill.snow.css' // 主题CSS
// Vue.use(VueQuillEditor)
Vue.prototype.$echarts = echarts
Vue.use(VueCropper)
// import Blob from './utils/excel/Blob.js'
// import Export2Excel from './utils/excel/Export2Excel.js'
import {
  isLogin
}
from './utils/dataStorage'
import {
  formatDate,
  numberFormat
} from './utils/index'

import App from './App.vue'

Vue.prototype.$Config = Config
Vue.prototype.$socketApi = socketApi

Vue.use(ElementUI)
import Axios from 'axios'
import {
  configUrl,
} from "@/utils";
router.beforeEach((to, from, next) => {
  // window.document.title = to.meta.title ? to.meta.title + '-' + Config.siteName : Config.siteName
  Axios.get(configUrl, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }).then(res => {
    window.document.title = to.meta.title ? to.meta.title + '-' + res.data.name : res.data.name;
  })
  if (!isLogin() && to.path !== '/login') {
    next({
      path: '/login'
    })
  } else {
    next()
  }
})
router.afterEach(transition => {

})

Vue.filter('dateTime', function(v) {
  if (!v) return '-'
  const date = new Date(parseInt(v))
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
})
Vue.filter('amountRMB', function(v) {
  return '￥' + numberFormat(v, 2)
})
Vue.filter('amountUSDT', function(v) {
  return (v / 100).toFixed(2)
})

var _vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

socketApi.initSocket(_vue);